import { render } from "./Sos.vue?vue&type=template&id=6e53e9b9&scoped=true"
import script from "./Sos.vue?vue&type=script&lang=js"
export * from "./Sos.vue?vue&type=script&lang=js"

import "./Sos.vue?vue&type=style&index=0&id=6e53e9b9&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e53e9b9"]])

export default __exports__